import {
  NetworkActivityTimeframeType,
  NetworkTopThreadStarterSenderFilter,
  ThreadExtendedActivityFilter,
  ThreadExtendedActivityTimeframeType,
  TopNetworkAnnouncementSortOrder,
  TopNetworkGroupSortOrder,
  TopNetworkThemeThreadSortOrder,
  TopNetworkThreadSortOrder,
  ViewerActivityThreadType,
  ViewerActivityTimeframeType,
  ViewerTopThreadType,
} from '@ms/yammer-graphql';

import { User } from '../types';

interface NetworkActivitySettings {
  readonly timeframe: NetworkActivityTimeframeType;
  readonly topThreadStarterSenderFilter: NetworkTopThreadStarterSenderFilter;
  readonly topNetworkAnnouncementSortOrder: TopNetworkAnnouncementSortOrder;
  readonly topNetworkGroupSortOrder: TopNetworkGroupSortOrder;
  readonly topNetworkThemeThreadSortOrder: TopNetworkThemeThreadSortOrder;
  readonly topNetworkThreadSortOrder: TopNetworkThreadSortOrder;
}

interface ViewerActivitySettings {
  readonly timeframe: ViewerActivityTimeframeType;
  readonly threadType: ViewerActivityThreadType;
  readonly topThreadType: ViewerTopThreadType;
}

export interface ThreadExtendedActivitySettings {
  readonly timeframe: ThreadExtendedActivityTimeframeType;
  readonly includePlatformActivity: boolean;
  readonly filterBy: ThreadExtendedActivityFilter;
  readonly filterEntityId?: string;
}

export enum ThreadExtendedActivityType {
  Others = 'forOthers',
  StorylineAnnouncement = 'forStorylineAnnouncement',
  CommunityAnnouncement = 'forCommunityAnnouncement',
}

export interface AnalyticsSettings {
  readonly selectedOnBehalfOfUserId: User['id'] | undefined;
  readonly networkActivitySettings: NetworkActivitySettings;
  readonly threadExtendedActivitySettingsForOthers: ThreadExtendedActivitySettings;
  readonly threadExtendedActivitySettingsForStorylineAnnouncement: ThreadExtendedActivitySettings;
  readonly threadExtendedActivitySettingsForCommunityAnnouncement: ThreadExtendedActivitySettings;
  readonly viewerActivitySettings: ViewerActivitySettings;
}
